module.exports = __webpack_public_path__ + "static/media/iv_aadhar.ebe0a49e.svg";